import { type MouseEvent, type MouseEventHandler, useCallback } from "react";

import { type IPlatformClick, trackPlatformClick } from "~/scripts/platformClick";

export const usePlatformClick = (
  { platform, placement, eventSlug }: IPlatformClick,
  onClick?: MouseEventHandler<HTMLElement>
): MouseEventHandler<HTMLElement> =>
  useCallback(
    (event: MouseEvent<HTMLElement>) => {
      trackPlatformClick({ platform, placement, eventSlug });
      onClick?.(event);
    },
    [platform, placement, eventSlug, onClick]
  );
